import moment from 'app/modules/datetime';
import lang from 'app/lib/moment/lang/ja';

moment.lang('ja', lang);



// WEBPACK FOOTER //
// ./src/web/js/app/datetime.ja.js